import React, { useState, useEffect, useRef } from 'react';
import ShowInformation from './subs/ShowInformation';
import { Editor } from '@tinymce/tinymce-react';
import {
  Grid, Table, TableContainer, Tab, Box, Typograph, TextField,
  Paper, TableCell, TableBody, TableRow, Typography, Autocomplete,
  Button, Fab, TableHead, FormControlLabel, Switch, Alert
} from '@mui/material';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import {
  Send, CloudDownload, DeleteForever, Close, HourglassTopTwoTone,
  KeyboardArrowUp, SkipNext, CloudUpload as CloudUploadIcon
} from '@mui/icons-material';
import { useSelector, useDispatch } from "react-redux";
import { setCargaDatos } from "../Redux/V2/ContratoRedux";
import { getConsentimiento, ReplaceTagsConsentimiento, descargarPdf, ReplaceTagsActualizacion } from "../Redux/V2/TagsRedux";
import { setCargaDatosFirma, resetActionFirma } from "../Redux/V2/FirmaRedux";
import { setCargaGeneral, getTemplateContratos } from "../Redux/GeneralDuck";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Swal from 'sweetalert2';

import { VisuallyHiddenInput } from '../components/VisualyHiddenInput';
import TareasEepp from './tareas_validacion/TareasEepp';
import Cookies from 'universal-cookie';

const formatter = new Intl.NumberFormat("es-CL"); // formato CLP (Chile)


const Contrato = ({ from, onChangeSave }) => {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const inputFileRef = useRef(null);

  const [valueTab, setValueTab] = useState("1");
  const [templateActive, setTemplateActive] = useState({})
  const [emailPagador, setEmailPagador] = useState(/*pagador?.email ?? */'');
  const [disabledComponent, setDisabledComponent] = useState(false);

  const [modalFirma, setModalFirma] = useState(false);
  const [enviandoFirma, setEnviandoFirma] = useState(false);
  const [recuperandoContrato, setRecuperandoContrato] = useState(false);
  const [visibleFab, setVisibleFab] = useState(false);
  const [checkedGD, setCheckedGD] = useState(true);
  const [contratoActualizacionActivo, setContratoActualizacionActivo] = useState({})
  const [showButtonAutorize, setShowButtonAutorize] = useState(false);


  const entrevista = useSelector((store) => store.contratoV2.Entrevista);
  const contrato = useSelector((store) => store.contratoV2.contrato); // servicios contratados
  const templateContratos = useSelector((store) => store.general.templateContratos);
  const documento = useSelector((store) => store.contratoV2.Documento);
  const pagador = useSelector((store) => store.contratoV2.Pagador);
  const defendido = useSelector((store) => store.contratoV2.Defendido);
  const firma = useSelector((store) => store.firmaV2.ElectronicSignature);
  const actualizacion = useSelector((store) => store.contratoV2.Actualizacion);
  const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
  const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
  const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);
  const contratoActualizacion = useSelector((store) => store.contratoV2.ContratoActualizacion);
  //const tags = useSelector((store) => store.tags);


  const bloqueadoTotalmente =
    !!contratoCancelado?.cancelado ||
    !!contratoFiniquitado?.finiquitado //|| (contratoFirmado?.firmado && !disabledComponent)

  useEffect(() => {
    let rolId = 0;
    try {
      const raw = cookies.get('rolId');
      if (raw != null) rolId = parseInt(raw, 10);
    } catch { /* noop */ }
    const lista = Array.isArray(window?.ROLID_VALIDA) ? window.ROLID_VALIDA : [];

    setShowButtonAutorize(!Number.isNaN(rolId) && lista.includes(rolId));
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      setVisibleFab(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    //if (actualizacion?.actualizacion?.status == 1) //si es actualizacion en curso
    //  setDisabledComponent(true)
  }, [actualizacion]);

  useEffect(() => {
    if (entrevista.id) {
      dispatch(getTemplateContratos(entrevista.lineaNegocioId));
      dispatch(setCargaDatos("Defendido", "get", entrevista.id))
      dispatch(setCargaDatos('Pagador', 'get', entrevista.id));
      dispatch(setCargaDatos("ContratoActualizacion", "get", entrevista.contractId));
      dispatch(setCargaDatos("Cuotas", "get", entrevista.id));
      //dispatch(setCargaDatos("Documento", "get", entrevista.id))
      //dispatch(setCargaDatos("contrato", "get", entrevista.contractId));
      //dispatch(setCargaDatos('ContratoFirmado', 'get', entrevista.id));
    }
  }, [entrevista.id])

  useEffect(() => {
    setEmailPagador(pagador?.email ?? '');
  }, [pagador]);

  useEffect(() => {
    console.log(contratoActualizacion)
    if (contratoActualizacion?.doc?.length > 0) {
      const myLayout = contratoActualizacion?.doc[0]
      const template = contratoActualizacion?.layouts.find(x => x.id == myLayout.id)
      setTemplateActive({
        ...documento,
        id: myLayout.id, //actualizacionId
        layoutId: myLayout.layoutId ?? null,
        html: myLayout.layout ?? null,
        name: myLayout.nameLayout ?? null
      })
      setContratoActualizacionActivo(myLayout)
    }
  }, [contratoActualizacion])


  const handlePrepareTemplate = async (value) => {

    if (bloqueadoTotalmente) return; // 🔒
    if (!value) return;
    if (value.id == templateActive.layoutId && templateActive.layoutId != 0) {
      return
    }
    else if (templateActive?.layoutId > 0 && value.id != templateActive.layoutId) {
      const result = await Swal.fire({
        title: 'Esta cambiando el template del contrato',
        text: 'El contrato anterior se borrará y perderá las modificaciones realizadas ¿Deseas continuar con esta acción?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;
    }
    setTemplateActive({
      ...documento,
      id: 0,
      layoutId: value.id,
      html: value.html,
      name: value.name,
    })
  }

  const handleConfirmReview = async () => {
    if (bloqueadoTotalmente) return; // 🔒
    if (templateActive.layoutId == null || templateActive.layoutId == 0) {
      Swal.fire({ icon: "warning", title: "Contrato no seleccionado" });
      return;
    }
    else if (documento.layoutId != 0 && documento.hmtl != templateActive.html) {
      const result = await Swal.fire({
        title: 'Confirmar edicion del contrato',
        html: `
        <p style="margin-bottom:12px; text-align:left;">Se está guardando una modificiación del contrato. </p>
        <div style="text-align:left">
          <label style="display:block; margin-bottom:6px;">
            <input type="radio" name="opcion" value="continuar" checked> Guardar y continuar editando
          </label>
          <label style="display:block; margin-bottom:6px;">
            <input type="radio" name="opcion" value="autorizar"> Pedir autorización para firmar y ejecutar ${actualizacion?.actualizacion?.type == 1 ? 'Actualización' : 'Cambio de estrategia'}
          </label>
        </div>`,
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        preConfirm: () => {
          const selected = document.querySelector('input[name="opcion"]:checked');
          if (!selected) {
            Swal.showValidationMessage('Debes elegir una opción');
            return false;
          }
          return selected.value;
        }
      });

      if (!result.isConfirmed) return;

      if (result.isConfirmed) {

        var payload = { ...templateActive }
        payload.actualizacionId = actualizacion?.actualizacion?.id
        if (result.value === "continuar") {
          await Swal.fire({
            icon: 'info',
            text: 'Guardado y continuar editando'
          });
          payload.continuar = true;
          payload.autorizar = false;

        } else if (result.value === "autorizar") {

          await Swal.fire({
            icon: 'success',
            text: 'Se ha enviado solicitud autorización'
          });
          payload.continuar = false;
          payload.autorizar = true;

        }
        dispatch(setCargaDatos("ContratoActualizacion", "patch", payload));
      }
    }
  }

  const handleAuthorize = async () => {
    const result = await Swal.fire({
      title: `Autorizar ${actualizacion?.actualizacion?.type == 1 ? 'actualización' : 'cambio de estrategia'}`,
      html: `
        <div style="text-align:left">
          <label style="display:block; margin-bottom:6px;">
            <input type="radio" name="opcion" value="con_firma" checked> Autorizar con firma del cliente
          </label>
          <label style="display:block; margin-bottom:6px;">
            <input type="radio" name="opcion" value="sin_firma"> Autorizar sin firma del cliente
          </label>
        </div>`,
      showCancelButton: true,
      confirmButtonText: 'Autorizar',
      cancelButtonText: 'Cancelar',
      preConfirm: () => {
        const selected = document.querySelector('input[name="opcion"]:checked');
        if (!selected) {
          Swal.showValidationMessage('Debes elegir una opción');
          return false;
        }
        return selected.value;
      }
    });

    if (!result.isConfirmed) return;

    if (result.isConfirmed) {
      var payload = {
        actualizacionId: actualizacion?.actualizacion?.id,
        firma: result.value === "con_firma" ? true : false,
        autorizar: true,
        contractId: entrevista.contractId
      }

      await Swal.fire({
        icon: 'success',
        text: 'Autorización enviada'
      });

      dispatch(setCargaDatos("ContratoActualizacion", "put", payload));

    }
  }

  const StatusAlert = ({ status, signed }) => {
    if (status == null)
      return <Alert severity="info">No Enviado</Alert>
    else if (status == 1 && signed == false)
      return <Alert severity="info">Pendiente firma Manual</Alert>
    else if (status == 2 && (signed == null || signed == undefined))
      return <Alert severity="info">Pendiente Firma GD</Alert>
    else if (status == 2 && signed != null && signed == false)
      return <Alert severity="info">Pendiente Firma GD</Alert>
    else if (signed != null && signed == true)
      return <Alert severity="success">Firmado GD</Alert>
  }

  const handleFirma = async (typeSign) => {
    setEnviandoFirma(true);
    var payload = preparePayloadSign(typeSign)
    await dispatch(setCargaDatos("ContratoActualizacion", "post", payload));
    setEnviandoFirma(false);
  }

  const checkFirma = async (typeSign, files) => {
    setRecuperandoContrato(true);
    var payload = preparePayloadSign(typeSign)
    payload.type = "get";

    if (typeSign == "MAN" && files != null) {
      const file = files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onloadend = async () => {
        payload.htmlB64 = reader.result.toString()
        await dispatch(setCargaDatos("ContratoActualizacion", "post", payload));
      };
      reader.readAsDataURL(file);
      await dispatch(setCargaDatos("Actualizacion", "get", entrevista.contractId))
      setRecuperandoContrato(false);
      return
    }
    await dispatch(setCargaDatos("ContratoActualizacion", "post", payload));
    await dispatch(setCargaDatos("Actualizacion", "get", entrevista.contractId))
    setRecuperandoContrato(false);

  }

  const deleteFirma = async (typeSign) => {
    var payload = preparePayloadSign(typeSign)
    payload.type = "delete";
    dispatch(setCargaDatos("ContratoActualizacion", "post", payload));
  }

  const handleNoFirma = async (typeSign) => {
    var payload = preparePayloadSign(typeSign)
    dispatch(setCargaDatos("ContratoActualizacion", "post", payload));
  }

  const preparePayloadSign = (typeSign) => {
    const _ActPagador = actualizacion?.actualizacionModelos?.find(x => x.model == "pagador")?.json
    const ActPagador = _ActPagador ? JSON.parse(_ActPagador) : null

    const payload = {
      typeSign, /* GD/MAN/NON */
      type: "send",
      actualizacionId: actualizacion?.actualizacion?.id,
      html: dispatch(ReplaceTagsActualizacion(templateActive.html ?? "")),
      paying: ActPagador ?? pagador,
      signatureType: checkedGD ? 12 : 13,
      ContractId: entrevista.contractId,
      services: "",
      clientIdentifier: defendido.identifier,
      htmlB64: ''//usar para ejecucion sin firma
    }
    return payload;
  }

  return (

    <div style={{ padding: "20px" }}>
      <ShowInformation from={from} />

      <Grid container className='p-2' justifyContent="flex-end" alignItems="center">
        <Grid item>

          {contratoActualizacionActivo?.authorize == true && contratoActualizacionActivo?.noSignature == true && contratoActualizacionActivo?.signed != true ?
            <Button
              variant="contained"
              color="primary"
              onClick={() => checkFirma("SINFIRMA", null)}
              disabled={disabledComponent || bloqueadoTotalmente /* 🔒 */ || recuperandoContrato}>
              Ejecutar {actualizacion?.actualizacion?.type == 1 ? 'Actualización' : 'Cambio de estrategia'} sin firma
            </Button>
            :
            contratoActualizacionActivo.authorize == true && actualizacion?.actualizacion?.status == 1 && contratoActualizacionActivo?.signed != true ?
              <Button variant="contained" color="primary" onClick={() => setModalFirma(true)} disabled={disabledComponent || bloqueadoTotalmente /* 🔒 */}> firmar {actualizacion?.actualizacion?.type == 1 ? 'Actualización' : 'Cambio de estrategia'}</Button>
              : contratoActualizacionActivo?.signed != true ? "Pendiente de autorizacion" : null
          }
        </Grid>
      </Grid>
      <TableContainer component={Paper} sx={{ marginBottom: 2 }}>

        <Grid container spacing={2} className='mb-2 mt-2'>
          {/* SELECCION DE CONTRATO*/}
          <Table>
            <TableBody>
              <TableRow>
                
                <TableCell className='w-25'><Typography className='m-3' variant="subtitle1" >Contrato para {actualizacion?.actualizacion?.type == 1 ? 'Actualización' : 'Cambio de estrategia'}:</Typography></TableCell>
                <TableCell className='w-75'>
                  <Autocomplete
                    getOptionLabel={(option) => option.name || ""}
                    disablePortal
                    options={contratoActualizacion?.layouts ?? []}
                    value={templateActive}
                    onChange={(event, value) => { handlePrepareTemplate(value) }}
                    renderInput={(params) => <TextField {...params} label="Seleccione Contrato" />}
                    disabled={disabledComponent || bloqueadoTotalmente || contratoActualizacionActivo.authorizationRequest != null}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
        {/* CONTRATO EDITABLE */}
        <TabContext value={valueTab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={(event, newValue) => setValueTab(newValue)}>
              <Tab label="Editar Contrato" value="1" />
              <Tab label="Ver Contrato" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <Editor
              tinymceScriptSrc='/tinymce/tinymce.min.js'
              licenseKey='GPL'
              //apiKey="no89skh86yibdbm71do29mqz4ldjyv6h6ix52vctyv798ztf"
              value={templateActive.html ?? ""}
              onEditorChange={(text) => {
                if (bloqueadoTotalmente) return // 🔒
                setTemplateActive((prev) => ({ ...prev, html: text }))
              }}
              disabled={disabledComponent || bloqueadoTotalmente || contratoActualizacionActivo.authorizationRequest != null}
              init={{
                height: 500,
                menubar: true,
                plugins: [
                  'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                  'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                  'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                ],
                toolbar: 'undo redo | blocks | ' +
                  'bold italic forecolor | alignleft aligncenter ' +
                  'alignright alignjustify | bullist numlist outdent indent | ' +
                  'removeformat | help',
              }}
            />
          </TabPanel>
          <TabPanel value="2">
            <Typography
              className='p-5'
              component="div"
              dangerouslySetInnerHTML={{ __html: dispatch(ReplaceTagsActualizacion(templateActive.html ?? "")) }}
            />
          </TabPanel>

          <Grid container className='p-2' justifyContent="flex-end" alignItems="center">
            <Grid item>

              {bloqueadoTotalmente || bloqueadoTotalmente ? (
                <Button
                  type="button"
                  variant="contained"
                  color="success"
                  startIcon={<SkipNext />}
                  size="large"
                  onClick={() => onChangeSave(4)}
                >
                  Continuar
                </Button>
              ) : contratoActualizacionActivo.authorizationRequest == null && actualizacion?.actualizacion?.status == 1 ?
                <Button
                  variant="contained"
                  color="primary" onClick={handleConfirmReview}
                >  confirmar revision
                </Button>
                :
                contratoActualizacionActivo?.authorize == null && actualizacion?.actualizacion?.status == 1 && showButtonAutorize ?
                  <Button
                    variant="contained"
                    color="primary" onClick={handleAuthorize}
                  >  Autorizar  {actualizacion?.actualizacion?.type == 1 ? 'Actualización' : 'Cambio de estrategia'}
                  </Button>
                  : null
              }
            </Grid>
          </Grid>
        </TabContext>
      </TableContainer>

      {visibleFab && (
        <Fab
          color="primary"
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1000,
          }}
        >
          <KeyboardArrowUp />
        </Fab>
      )}

      <Dialog
        open={modalFirma}
        onClose={() => setModalFirma(false)}
      >
        <DialogTitle>
          {`Firmar ${actualizacion?.actualizacion?.type == 1 ? 'Actualización' : 'Cambio de estrategia'}`}
          {contratoActualizacionActivo.authorize == true && contratoActualizacionActivo.noSignature == true ? null : " / Autorizado con firma"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>

            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Modo Firma</TableCell>
                    <TableCell align="right">Enviar</TableCell>
                    <TableCell align="right">Revisar</TableCell>
                    <TableCell align="right">Cancelar</TableCell>
                    <TableCell align="right">Estado</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">FIRMA GD</TableCell>
                    <TableCell align="right">
                      <FormControlLabel hidden={firma["grupoDefensa"]?.estado != "No Enviado"}
                        control={
                          <Switch
                            checked={checkedGD}
                            onChange={(event) => { if (!bloqueadoTotalmente) setCheckedGD(event.target.checked); }} // 🔒
                            color="warning"
                            disabled={bloqueadoTotalmente}
                          />
                        }
                        label={checkedGD ? 'con Firma' : 'con Codigo'}
                      />

                      <Button
                        onClick={() => handleFirma("GD")}
                        color="success"
                        variant="text"
                        hidden={contratoActualizacionActivo.methodSign != null}
                        disabled={bloqueadoTotalmente || enviandoFirma}
                      >
                        {enviandoFirma ? <HourglassTopTwoTone /> : <Send />}
                      </Button>
                    </TableCell>
                    <TableCell align="right">
                      <Button onClick={() => checkFirma("GD")} color="info" variant="text"
                        hidden={!(contratoActualizacionActivo.methodSign == 2 && contratoActualizacionActivo.signed == false)}
                        disabled={bloqueadoTotalmente || recuperandoContrato}>
                        {recuperandoContrato ? <HourglassTopTwoTone /> : <CloudDownload />}</Button>
                    </TableCell>
                    <TableCell align="right">
                      <Button onClick={() => deleteFirma("GD")} color="error" variant="text" hidden={!(contratoActualizacionActivo.methodSign == 2 && contratoActualizacionActivo.signed == false)} disabled={bloqueadoTotalmente || recuperandoContrato}><DeleteForever /></Button></TableCell>
                    <TableCell align="right">
                      <StatusAlert status={contratoActualizacionActivo.methodSign} signed={contratoActualizacionActivo.signed} />
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell component="th" scope="row">MANUAL</TableCell>
                    <TableCell align="right">
                      <Button
                        onClick={() => handleFirma("MAN")}
                        color="success"
                        variant="text"
                        hidden={contratoActualizacionActivo.methodSign != null}
                        disabled={bloqueadoTotalmente || enviandoFirma}
                      >
                        {enviandoFirma ? <HourglassTopTwoTone /> : <Send />}
                      </Button>
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        color="info"
                        variant="text"
                        onClick={() => !bloqueadoTotalmente && inputFileRef.current && inputFileRef.current.click()} // 🔒
                        hidden={!(contratoActualizacionActivo.methodSign == 1 && contratoActualizacionActivo.signed == false)}
                        disabled={bloqueadoTotalmente || recuperandoContrato}
                      >
                        {recuperandoContrato ?
                          <HourglassTopTwoTone />
                          : <>
                            <CloudUploadIcon fontSize="medium" />
                            <VisuallyHiddenInput
                              type="file"
                              ref={inputFileRef}
                              onChange={(event) => {
                                checkFirma("MAN", event.target.files)
                              }}
                              multiple
                              style={{ display: 'none' }}
                            />
                          </>
                        }
                      </Button>
                    </TableCell>

                    <TableCell align="right">
                      <Button onClick={() => deleteFirma("MAN")} color="error" variant="text" hidden={!(contratoActualizacionActivo.methodSign == 1 && contratoActualizacionActivo.signed == false)} disabled={bloqueadoTotalmente || recuperandoContrato}><DeleteForever /></Button>
                    </TableCell>
                    <TableCell align="right">
                      <StatusAlert status={contratoActualizacionActivo.methodSign} signed={contratoActualizacionActivo.signed} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>


          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalFirma(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </div >
  );
};

export default Contrato;
